var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49992 19.9873L11.0795 16.5H18.3333C19.3458 16.5 20.1666 15.6792 20.1666 14.6667V3.66671C20.1666 2.65419 19.3458 1.83337 18.3333 1.83337H3.66659C2.65406 1.83337 1.83325 2.65419 1.83325 3.66671V14.6667C1.83325 15.6792 2.65406 16.5 3.66659 16.5H5.49992V19.9873ZM10.5537 14.6667L7.33325 16.6795V14.6667H3.66659V3.66671H18.3333V14.6667H10.5537ZM6.41658 11.9167V10.0834H12.8333V11.9167H6.41658ZM6.41658 6.41671V8.25004H14.6666V6.41671H6.41658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.abfd58bd92110153ef593ea3382dafc9.svg";
export { ForwardRef as ReactComponent };